import { useEffect } from 'react';
import { useProductCompareContext } from '../context';

type UseInitializeSelectedProductsProps = {
  recentlyViewedProductIds: number[];
  recommendationProductIds: number[];
};

export const useInitializeSelectedProducts = ({
  recentlyViewedProductIds,
  recommendationProductIds,
}: UseInitializeSelectedProductsProps) => {
  const { selectedProductId, setSelectedProductId, currentProductId } = useProductCompareContext();

  useEffect(() => {
    const needsRecentlyViewedInit = recentlyViewedProductIds.length > 0 && !selectedProductId.recentlyViewedProductId;
    const needsRecommendationInit = recommendationProductIds.length > 0 && !selectedProductId.recommendationProductId;

    if (needsRecentlyViewedInit || needsRecommendationInit) {
      const isCurrentProductInList = currentProductId && recentlyViewedProductIds.includes(currentProductId);
      const defaultRecentlyViewedId = isCurrentProductInList ? currentProductId : recentlyViewedProductIds[0];

      setSelectedProductId((prev) => ({
        ...prev,
        ...(needsRecentlyViewedInit && { recentlyViewedProductId: defaultRecentlyViewedId }),
        ...(needsRecommendationInit && { recommendationProductId: recommendationProductIds[0] }),
      }));
    }
  }, [
    recentlyViewedProductIds,
    recommendationProductIds,
    selectedProductId.recentlyViewedProductId,
    selectedProductId.recommendationProductId,
    setSelectedProductId,
    currentProductId,
  ]);
};
